const Strikethrough = ({ children }) => {
    return (
        <span className="strikethrough">
            {children}
        </span>
    )
}
  
export default Strikethrough